<template>
    <TprmModal
        open
        :title="title"
        additional-class-name="ActionReviewRejectionModal"
        size="default"
        :allow-close="false"
        @close="$emit('close')"
    >
        {{ message }}

        <template #footer>
            <NewButton
                variant="outline"
                color="neutral"
                @click="$emit('input', false)"
            >
                {{ cancelButtonLabel }}
            </NewButton>
            <NewButton
                variant="fill"
                color="danger"
                @click="$emit('input', true)"
            >
                {{ confirmButtonLabel }}
            </NewButton>
        </template>
    </TprmModal>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    export default defineComponent({
        name: 'ActionReviewRejectionModal',
        components: {
            TprmModal,
            NewButton,
        },
        props: {
            title: {
                type: String as PropType<string>,
                default: 'Decline Document',
            },
            message: {
                type: String as PropType<string>,
                default: 'Declining this document will reject the review, mark the entity as non-compliant and they will be notified. This action can not be undone.',
            },
            cancelButtonLabel: {
                type: String as PropType<string>,
                default: 'Cancel',
            },
            confirmButtonLabel: {
                type: String as PropType<string>,
                default: 'Decline Document',
            },
        },
        emits: [ 'close', 'input' ],
    });
</script>
